import type { LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

const COLOR_PATTERN = {
  gold: {
    right: '#FFC107',
    left: '#EEB509',
  },
  silver: {
    right: '#E0E0E0',
    left: '#C0C0C0',
  },
  black: {
    right: '#666666',
    left: '#000000',
  },
  full_black: {
    right: '#000000',
    left: '#000000',
  },
  half_gold: {
    right: '#FFC107',
    left: '#e0e0e0',
  },
}

export const ReviewStar = forwardRef<SVGSVGElement, LucideProps & { pattern?: keyof typeof COLOR_PATTERN }>(
  ({ size = 24, pattern = 'gold', ...props }, ref) => {
    const colors = COLOR_PATTERN[pattern]

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M25.9357 9.44715C25.7656 8.91887 25.2986 8.54385 24.746 8.49385L17.2405 7.81012L14.2728 0.841341C14.0539 0.330449 13.5555 0 13.0018 0C12.4482 0 11.9498 0.330449 11.7309 0.842428L8.76317 7.81012L1.25663 8.49385C0.705125 8.54494 0.239217 8.91887 0.0680225 9.44715C-0.103172 9.97543 0.0550204 10.5548 0.472171 10.92L6.14541 15.9116L4.47248 23.3043C4.35004 23.8478 4.56024 24.4098 5.0099 24.7359C5.25152 24.9109 5.53432 25 5.81928 25C6.06523 25 6.30902 24.9337 6.52789 24.8022L13.0018 20.9205L19.4736 24.8022C19.946 25.088 20.5441 25.062 20.9927 24.7359C21.4424 24.4087 21.6526 23.8467 21.5301 23.3043L19.8572 15.9116L25.5304 10.9211C25.9476 10.5548 26.1069 9.97652 25.9357 9.44715Z"
          fill={colors.left}
        />
        <path
          d="M13.0018 0C12.4482 0 11.9498 0.330449 11.7309 0.842428L8.76317 7.81012L1.25663 8.49385C0.705125 8.54494 0.239217 8.91887 0.0680225 9.44715C-0.103172 9.97543 0.0550204 10.5548 0.472171 10.92L6.14541 15.9116L4.47248 23.3043C4.35004 23.8478 4.56024 24.4098 5.0099 24.7359C5.25152 24.9109 5.53432 25 5.81928 25C6.06523 25 6.30902 24.9337 6.52789 24.8022L13.0018 20.9205V0Z"
          fill={colors.right}
        />
      </svg>
    )
  },
)

ReviewStar.displayName = 'ReviewStar'
